import AccountService from "./../shared/services/accountService";

const READY_CHANGE_STORE_SEND_MAIL = "READY_CHANGE_STORE_SEND_MAIL";

const responseChangeStoreSendMailAction = (name, value) => {
  return {
    type: READY_CHANGE_STORE_SEND_MAIL,
    payload: { name, value },
  };
};

const handleChangeStoreSendMail = (name, value) => {
  return (dispatch) => {
    dispatch(responseChangeStoreSendMailAction(name, value));
  };
};

const REQUEST_SEND_MAIL = "REQUEST_SEND_MAIL";
const RESPONSE_SEND_MAIL = "RESPONSE_SEND_MAIL";
const REQUEST_SEND_MAIL_FAILURE = "REQUEST_SEND_MAIL_FAILURE";

const requestSendMailAction = () => {
  return {
    type: REQUEST_SEND_MAIL,
  };
};

const responseSendMailAction = (data) => {
  return {
    type: RESPONSE_SEND_MAIL,
  };
};

const requestSendMailfailureAction = (errors) => {
  return {
    type: REQUEST_SEND_MAIL_FAILURE,
    errors,
  };
};

const sendMail = (data) => {
  return (dispatch) => {
    dispatch(requestSendMailAction());

    AccountService.sendEmail(data)
      .then((result) => {
        dispatch(responseSendMailAction());
      })
      .catch((error) => {
        dispatch(requestSendMailfailureAction(error.response));
      });
  };
};

const REQUEST_GET_RESTORE_DATA = "REQUEST_GET_RESTORE_DATA";
const RESPONSE_GET_RESTORE_DATA = "RESPONSE_GET_RESTORE_DATA";
const REQUEST_GET_RESTORE_DATA_FAILURE = "REQUEST_GET_RESTORE_DATA_FAILURE";

const requestGetRestoreDataAction = () => {
  return {
    type: REQUEST_GET_RESTORE_DATA,
  };
};

const responseGetRestoreDataAction = (data) => {
  return {
    type: RESPONSE_GET_RESTORE_DATA,
    data,
  };
};

const requestGetRestoreDataFailureAction = (errors) => {
  return {
    type: REQUEST_GET_RESTORE_DATA_FAILURE,
    errors,
  };
};

const getRestoreData = (data) => {
  return (dispatch) => {
    dispatch(requestGetRestoreDataAction());

    AccountService.getRestoreData(data)
      .then((result) => {
        dispatch(responseGetRestoreDataAction(result.data));
      })
      .catch((error) => {
        dispatch(requestGetRestoreDataFailureAction(error.response));
      });
  };
};

const REQUEST_RESTORE_PASSWORD = "REQUEST_RESTORE_PASSWORD";
const RESPONSE_RESTORE_PASSWORD = "RESPONSE_RESTORE_PASSWORD";
const REQUEST_RESTORE_PASSWORD_FAILURE = "REQUEST_RESTORE_PASSWORD_FAILURE";

const requestRestorePasswordAction = () => {
  return {
    type: REQUEST_RESTORE_PASSWORD,
  };
};

const responseRestorePasswordAction = (data) => {
  return {
    type: RESPONSE_RESTORE_PASSWORD,
    data,
  };
};

const requestRestorePasswordFailureAction = (errors) => {
  return {
    type: REQUEST_RESTORE_PASSWORD_FAILURE,
    errors,
  };
};

const restorePassword = (data) => {
  return (dispatch) => {
    dispatch(requestRestorePasswordAction());

    AccountService.restorePassword(data)
      .then((result) => {
        dispatch(responseRestorePasswordAction());
      })
      .catch((error) => {
        dispatch(requestRestorePasswordFailureAction(error.response));
      });
  };
};

export {
  READY_CHANGE_STORE_SEND_MAIL,
  handleChangeStoreSendMail,
  REQUEST_SEND_MAIL,
  RESPONSE_SEND_MAIL,
  REQUEST_SEND_MAIL_FAILURE,
  sendMail,
  REQUEST_GET_RESTORE_DATA,
  RESPONSE_GET_RESTORE_DATA,
  REQUEST_GET_RESTORE_DATA_FAILURE,
  getRestoreData,
  REQUEST_RESTORE_PASSWORD,
  RESPONSE_RESTORE_PASSWORD,
  REQUEST_RESTORE_PASSWORD_FAILURE,
  restorePassword,
};
